module.exports = __webpack_public_path__ + "img/KInplay.de70620c.jpeg";